import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from 'src/app/@auth/auth.service';

@Injectable()
export class OrderPortailInterceptor implements HttpInterceptor
{
    constructor( private _router : Router, private _authService: AuthService ) { }

    /**
     * Intercept
     *
     * @param req
     * @param next
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
    {
        // Clone the request object
        let newReq = req.clone();
        if(newReq.url.indexOf('/api/FO') > - 1){
            let SITEGID : string = '';
            try { 
                const authSessionDto: any = this._authService.authenticatedSession$.value; 
                if(authSessionDto && authSessionDto.SITE_ITEM && authSessionDto.SITE_ITEM.SITEGID) { SITEGID = authSessionDto.SITE_ITEM.SITEGID; }
            } catch { }
            newReq = req.clone({
                headers: req.headers.set('SITEGID', SITEGID)
            });
        }
        // Response
        return next.handle(newReq).pipe(
            catchError((error) => {
                console.log(error);
                return throwError(error);
            })
        );
    }
}
